import { Link } from "../components/Actions";
import NFTPill from "../components/NFTPill/NFTPill";
import SEO from "../components/Seo/Seo";

const Join = () => {
  return (
    <>
      <SEO title="Network Join | Coinage Media" />
      <section className="flex max-w-4xl p-8 py-16 flex-col items-center mx-auto gap-8">
        <h1 className="subhead1 text-center">
          Apply for a Network Membership Pass. <br /> Get priority access to
          co-own Coinage.
        </h1>
        <p className="body1 text-coinage-body max-w-prose text-center">
          If you’re selected, we’ll reach out to you directly with an individual
          referral link to mint.
        </p>
        <NFTPill
          video="/network/network600.mp4"
          title={"Network Membership Pass"}
          price={{
            label: "",
            hideEth: true,
            hideTransactionFee: true
          }}
        />

        <Link
          analyticsProperty="coinage premint"
          modifier="primary"
          href="https://www.premint.xyz/coinage-network-nft">
          Register with PREMINT
        </Link>
      </section>
    </>
  );
};

export default Join;
